<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/MJxe34/tc-custom/9780062133588.jpg?1713988110396" alt="This image is the cover for the book Skinny-Dipping"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Skinny-Dipping
      </h1>
      <p class="bookDescription body article font2">
        <p>Lilly Cleary is an attorney for a prestigious Sarasota law firm. But her killer cross-examination technique and take-no-prisoners courtroom attitude haven't stopped the senior partners from dumping one stink bomb after another on her desk—like the kayak-whiplash case she's currently saddled with. And problems at home, specifically with her ex–boyfriend, aren't making her disposition any sunnier.</p><p> But it isn't until she's mugged outside her office that her troubles really begin. And when someone puts a bullet hole in her favorite suit, Lilly realizes things are getting a bit too personal. Perhaps it has something to do with a malpractice lawsuit she's inherited, and her recently and suspiciously deceased doctor client. Lilly's not going to take the insult lying down—even if tracking a killer leads her into dangerously deep water.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Claire Matturro
      </h2>
      
      <p class="authorDescription body article"><P>A former appellate attorney and former member of the writing faculty at Florida State University College of Law and the University of Oregon School of Law, Claire Hamner Matturro lives in Georgia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?40d99440